const throwAppError = () => {
    throw new Error('App not found')
}

export default throwAppError